module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="modal-header">\n	<h3 class="modal-title">View Statements in TriG</h3>\n</div>\n<div class="modal-body">\n\n	<pre>{{trig}}</pre>\n	\n</div>\n<div class="modal-footer">\n	<button class="btn btn-primary btn-sm" ng-click="cancel()">Cancel</button>\n</div>';

}
return __p
}